<template>
  <v-app id="inspire">
    <v-content style="background: #f9fafb">
      <v-container style="max-width: 1400px" class="fill-height" fluid>
        <v-row class="parent-container">
          <v-col
            cols="12"
            lg="5"
            style="
              text-align: center;
              width: 100%;
              background: white;
              border-radius: 24px;
              border: 1px solid #e4e7ec;
              height: min-content;
            "
          >
            <img src="@/assets/frink-logo.png" style="width: 150px" />

            <v-card
              style="
                margin-top: 10px;
                width: 100%;
                border: none;
                box-shadow: unset;
              "
            >
              <v-tabs
                v-model="tab"
                background-color="grey lighten-4"
                grow
                slider-color="#4d48f9"
                @change="clearErrors"
              >
                <v-tab style="text-transform: none">Giriş Yap</v-tab>
                <v-tab style="text-transform: none">Yeni Başvuru</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card-text>
                    <v-form
                      id="check-login-form"
                      ref="loginForm"
                      v-model="isLoginValid"
                      lazy-validation
                      @submit.prevent="userLogin"
                    >
                      <v-text-field
                        v-model="userData.email"
                        name="email"
                        prepend-icon="person"
                        :rules="emailRules"
                        label="Eposta"
                        required
                        type="text"
                      />

                      <v-text-field
                        id="password"
                        v-model="userData.password"
                        name="password"
                        prepend-icon="lock"
                        :rules="passwordRules"
                        label="Şifre"
                        type="password"
                        required
                      />
                    </v-form>
                    <router-link
                      to="/forgotPassword"
                      active-class="active"
                      style="margin-left: 5px; float: left"
                    >
                      Şifremi unuttum
                    </router-link>
                  </v-card-text>
                  <v-card-actions style="width: 100%; padding: 40px 32px">
                    <v-spacer />
                    <v-btn
                      type="submit"
                      color="#4d48f9"
                      form="check-login-form"
                      style="
                        text-transform: none !important;
                        color: white;
                        border-radius: 24px;
                        width: 100%;
                        height: 48px;
                        font-size: 16px;
                      "
                      :disabled="!isLoginValid"
                    >
                      Giriş yap
                    </v-btn>
                  </v-card-actions>
                </v-tab-item>

                <v-tab-item>
                  <v-card-text>
                    <v-form
                      v-if="merchantApplyStep == 1"
                      id="apply-form"
                      ref="apply-form"
                      v-model="isApplyValid"
                      lazy-validation
                      @submit.prevent="onClickApply"
                    >
                      <v-text-field
                        v-model="merchantFormData.companyName"
                        name="venueName"
                        label="Mağaza Adı"
                        required
                        type="text"
                        @input="updateFormData"
                        :rules="venueNameRules"
                      />
                      <v-text-field
                        v-model="merchantFormData.authorizedPerson"
                        name="venueName"
                        label="Yetkili"
                        required
                        type="text"
                        @input="updateFormData"
                        :rules="fullNameRules"
                      />
                      <v-text-field
                        v-model="merchantFormData.phoneNumber"
                        label="Telefon Numarası"
                        v-mask="'(+90) ### ### ## ##'"
                        required
                        type="text"
                        :rules="phoneNumberRules"
                        @input="updateFormData"
                      />
                      <v-text-field
                        v-model="merchantFormData.authorizedPersonMail"
                        @input="onEmailChange"
                        :rules="emailRules"
                        label="Eposta"
                        required
                        type="text"
                        @keydown.space.prevent
                      />
                      <v-textarea
                        v-model="merchantFormData.companyAddress"
                        label="Adres"
                        required
                        type="text"
                        multipleline
                        @input="updateFormData"
                        :rules="addressRules"
                      />
                      <div class="consent-checkbox-container">
                        <v-checkbox
                          color="success"
                          v-model="etkContract"
                          @change="updateFormData"
                        ></v-checkbox>

                        <div class="consent-checkbox-text">
                          Kişisel verilerimin,
                          <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                              <span
                                style="
                                  cursor: pointer;
                                  text-decoration: underline;
                                "
                                v-bind="props"
                                @click="onClickContract"
                              >
                                <b>Aydınlatma Metni</b>
                              </span>
                            </template>
                          </v-tooltip>
                          ’ nde belirtilen işleme amaçlarıyla sınırlı olmak
                          üzere yurtdışına aktarılmasını açık rızamla kabul
                          ediyorum.
                        </div>
                      </div>
                      <!-- <v-checkbox
                        color="success"
                        label="success"
                        value="success"
                        v-model="checkbox"
                      >
                        <template v-slot:label>
                          <div class="consent-checkbox-text">
                            <v-tooltip location="bottom">
                              <template v-slot:activator="{ props }">
                                <a
                                  href="https://vuetifyjs.com"
                                  target="_blank"
                                  v-bind="props"
                                  @click.stop
                                >
                                  Üyelik Sözleşmesini
                                </a>
                              </template>
                            </v-tooltip>
                            okudum, kabul ediyorum
                          </div>
                        </template>
                      </v-checkbox> -->

                      <v-spacer />
                      <v-btn
                        type="submit"
                        color="#4d48f9"
                        form="apply-form"
                        style="
                          text-transform: none !important;
                          color: white;
                          border-radius: 24px;
                          width: 100%;
                          height: 48px;
                          font-size: 16px;
                        "
                        :disabled="isButtonDisabled"
                      >
                        Başvur
                      </v-btn>
                    </v-form>
                    <div class="apply-otp" v-else-if="merchantApplyStep == 2">
                      <p style="font-size: 20px">Onay Kodu</p>
                      <p style="font-size: 16px">
                        {{
                          merchantFormData.mail
                            .split("@")[0]
                            .substring(
                              0,
                              merchantFormData.mail.split("@")[0].length / 2
                            )
                        }}***@*****.com e-posta adresine gönderilen 6 haneli
                        onay kodunu girin.
                      </p>
                      <div
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                        "
                      >
                        <p v-if="expiresIn > 0">{{ expiresIn }}</p>
                        <p style="color: #ff0f12" v-else>Süre doldu.</p>
                        <div style="width: 260px">
                          <v-otp-input
                            v-if="isClient"
                            :disabled="expiresIn <= 0"
                            v-model="otp"
                            :length="6"
                            name="otp"
                            type="number"
                            @input="onOtpInput"
                            :error="isOtpWrong"
                            @keypress="onlyNumbers"
                          ></v-otp-input>
                        </div>
                        <div style="display: flex; gap: 8px">
                          <p style="font-size: 14px">OTP kodu almadınız mı?</p>
                          <div
                            :style="{
                              color: expiresIn < 1 ? '#4d48f9' : 'gray',
                              textDecoration: 'underline',
                              fontSize: '15px',
                              cursor: expiresIn < 1 ? 'pointer' : 'not-allowed',
                            }"
                            @click="
                              () => {
                                if (expiresIn < 1) {
                                  sendOtp();
                                }
                              }
                            "
                          >
                            Tekrar Gönder
                          </div>
                        </div>
                        <v-btn
                          type="submit"
                          color="#4d48f9"
                          style="
                            color: white;
                            text-transform: capitalize;
                            margin-top: 12px;
                          "
                          :disabled="
                            !(otp.length == 6) || isOtpWrong || isOtpSending
                          "
                          @click="() => confirmOtp()"
                        >
                          {{ merchantApplyStep == 2 ? "Doğrula" : "Onayla" }}
                        </v-btn>
                      </div>
                    </div>
                    <div class="apply-success" v-else>
                      <img
                        src="@/assets/icons/success.svg"
                        style="width: 64px; height: 64px"
                      />

                      <div class="description">
                        <h3>Başvurunuz Onaya Gönderildi!</h3>
                        <p>
                          Gerekli incelemeler tamamlandıktan sonra en kısa
                          sürede size geri dönüş yapılacaktır.
                        </p>
                      </div>
                    </div>
                  </v-card-text>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
          <v-col cols="12" lg="7" class="login-hero-container">
            <div class="login-hero">
              <v-carousel cycle height="100%" hide-delimiter-background>
                <v-carousel-item
                  v-for="(slide, i) in activeSlides"
                  :key="i"
                  class="login-hero-container"
                >
                  <v-sheet height="100%" style="border-radius: 24px">
                    <div class="login-hero-text">
                      <!-- {{ slide.text }} -->
                    </div>

                    <img :src="slide.img" />
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </div>
            <div class="company-infos">
              <div class="company-info">
                <img src="@/assets/icons/shop.svg" />
                <div>
                  <h4>500+</h4>
                  <h5>İşletme</h5>
                </div>
              </div>
              <div class="company-info">
                <img src="@/assets/icons/coffee.svg" />
                <div>
                  <h4>200.000+</h4>
                  <h5>Ürün Satışı</h5>
                </div>
              </div>
              <div class="company-info">
                <img src="@/assets/icons/person.svg" />
                <div>
                  <h4>10.000+</h4>
                  <h5>Müşteri</h5>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="600">
          <v-card>
            <v-card-title class="headline">
              Lütfen alanları kontrol edin
            </v-card-title>
            <v-card-text>
              <ul>
                <li v-for="error in errorList" :key="error">{{ error }}</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="contractDialogOpen" max-width="600">
          <v-card class="contract-card">
            <div v-html="contractDetails" class="contract-content"></div>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VOtpInput from "vue-otp-input";
import { ref } from "vue";

export default {
  name: "Login",
  components: {
    VOtpInput,
  },
  data: () => ({
    isLoginValid: false,
    isApplyValid: false,
    isClient: false,
    userData: { email: "", password: "" },
    passwordRules: [(v) => !!v || "Lütfen zorunlu alanları doldurun."],
    fullNameRules: [
      (v) => !!v || "Ad ve soyadı doğru bir formatta yazınız.",
      (v) =>
        (v && v.length <= 255) || "Ad ve soyadı doğru bir formatta yazınız.",
      (v) => {
        const parts =
          v &&
          v
            .trim()
            .split(" ")
            .filter((part) => part.length > 0);
        return (
          (parts &&
            parts.length >= 2 &&
            parts.every((part) => part.length >= 2)) ||
          "Ad ve soyadı doğru bir formatta yazınız."
        );
      },
      (v) =>
        /^[A-Za-zğüşıöçĞÜŞİÖÇ\s]*$/.test(v) ||
        "Ad ve soyadı doğru bir formatta yazınız.",
    ],
    phoneNumberRules: [
      (v) => !!v || "Telefon numarası alanı zorunludur.",
      (v) =>
        v.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "").length ===
          13 || "Telefon numarası hatalı!",
    ],
    venueNameRules: [
      (v) => !!v || "Mağaza adı alanı zorunludur.",
      (v) => v.length > 1 || "Mağaza adı hatalı!",
    ],
    addressRules: [
      (v) => !!v || "Adres alanı zorunludur.",
      (v) => v && v.length > 4 || "Adres hatalı!",
    ],
    errorList: [],
    dialog: false,
    tab: ref(0),
    slides: {
      desktop: [
        {
          img: require("@/assets/login-hero-desktop-1.jpg"),
        },
        {
          img: require("@/assets/login-hero-desktop-2.jpg"),
        },
      ],
      mobile: [
        {
          img: require("@/assets/login-hero-mobile-1.jpg"),
        },
        {
          img: require("@/assets/login-hero-mobile-2.jpg"),
        },
      ],
    },
    isButtonDisabled: true,
    merchantFormData: {
      companyName: "",
      ownerName: "",
      phoneNumber: "",
      mail: "",
      address: "",
    },
    etkContract: "",
    merchantApplyStep: 1,
    otp: "",
    expiresIn: 180,
    isOtpWrong: false,
    isOtpSending: false,
    contractDialog: "",
    contractDialogOpen: false,
  }),
  mounted() {
    this.isClient = true;
    this.getContract("ClarificationText");
    const hash = window.location.hash;
    if (hash === "#apply") {
      this.tab = 1;
    }
  },
  methods: {
    ...mapActions(["userAuth"]),
    ...mapActions("applyMerchantForm", [
      "saveFormData",
      "postApplyMerchantForm",
      "postSendOtp",
      "postConfirmOtp",
      "getCheckByEmail",
    ]),
    ...mapActions(["getPanelUserById"]),
    ...mapActions("contract", ["getContract"]),
    updateFormData() {
      this.saveFormData(this.merchantFormData);
      this.checkNewApplicationForm();
    },
    fullNameCheck(value) {
      const parts = value
        .trim()
        .split(" ")
        .filter((part) => part.length > 0);
      return parts.length >= 2 && parts.every((part) => part.length >= 2);
    },
    checkNewApplicationForm() {
      const data = this.getFormData();
      if (
        data.companyName &&
        data.companyName.trim() &&
        data.authorizedPerson &&
        data.authorizedPerson.trim() &&
        this.fullNameCheck(data.authorizedPerson) &&
        data.phoneNumber &&
        data.phoneNumber.replaceAll(" ", "").length === 15 &&
        data.authorizedPersonMail &&
        data.authorizedPersonMail.trim() &&
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(data.mail) &&
        data.companyAddress &&
        data.companyAddress.trim() &&
        this.etkContract
      ) {
        this.isButtonDisabled = false;
      } else this.isButtonDisabled = true;
    },
    onEmailChange(value) {
      this.merchantFormData.mail = value.replaceAll(" ", "");
      this.updateFormData();
    },
    userLogin() {
      if (this.$refs.loginForm.validate()) {
        this.userAuth(this.userData);
      } else {
        const errors = [];
        const x = document.getElementsByClassName("v-messages__message");
        for (let i = 0; i < x.length; i++) errors.push(x[i].innerHTML);
        this.errorList = errors;
        this.dialog = true;
      }
    },
    sendOtp() {
      this.postSendOtp({
        email: this.merchantFormData.mail,
        authorizedPerson: this.merchantFormData.authorizedPerson,
      }).then((res) => {
        this.expiresIn = res.expiresIn;
        this.merchantApplyStep = 2;
        this.startOtpTimer();
      });
    },
    confirmOtp() {
      this.isOtpSending = true;

      this.postConfirmOtp({
        email: this.merchantFormData.mail,
        code: this.otp,
        etkContract: this.etkContract,
      })
        .then((isSuccess) => {
          if (isSuccess) {
            this.applyMerchant();
          }
        })
        .catch((err) => {
          if (err.response.data) {
            const errorKey = err.response.data.friendlyMessage.message;
            if (errorKey == "invalid_otp") {
              this.isOtpWrong = true;
              alert("Lütfen girmiş olduğunuz doğrulama kodunu kontrol edin.");
            }
            if (errorKey == "too_many_incorrect_otp") {
              alert("Çok fazla sayıda hatalı giriş yaptınız.");
            }
          }
        })
        .finally(() => {
          this.isOtpSending = false;
        });
    },
    applyMerchant() {
      this.postApplyMerchantForm().then((isSuccess) => {
        if (isSuccess) {
          this.merchantApplyStep = 3;
        }
      });
    },
    onClickApply() {
      this.getCheckByEmail(this.merchantFormData.mail)
        .then((canApply) => {
          if (canApply) {
            this.sendOtp();
          }
        })
        .catch((err) => {
          if (err.response.data) {
            const errorKey = err.response.data.friendlyMessage.message;
            if (errorKey == "user_already_registered") {
              alert(
                "Girmiş olduğunuz e-posta adresi ile bir kullanıcı mevcut."
              );
            }
            if (errorKey == "application_already_exists") {
              alert(
                "Girmiş olduğunuz e-posta adresi ile henüz onaylanmamış bir başvurunuz bulunmaktadır. Başvuru süreci tamamlandığında ekibimiz en kısa sürede sizinle iletişime geçecektir."
              );
            }
          }
        })
        .finally(() => {
          this.isOtpSending = false;
        });
    },
    startOtpTimer() {
      if (this.expiresIn > 0) {
        this.intervalid1 = setInterval(() => {
          this.expiresIn -= 1;
        }, 1000);
      }
    },
    clearErrors() {
      this.$nextTick(() => {
        if (this.$refs.loginForm) this.$refs.loginForm.resetValidation();
        if (this.$refs["apply-form"])
          this.$refs["apply-form"].resetValidation();
      });
    },
    onOtpInput() {
      this.isOtpWrong = false;
    },
    onlyNumbers(event) {
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },
    onClickContract() {
      this.contractDialogOpen = true;
    },
  },
  computed: {
    ...mapGetters("applyMerchantForm", ["getFormData"]),
    ...mapGetters("contract", ["contractDetails"]),
    emailRules() {
      return [
        (v) => !!v || "Lütfen zorunlu alanları doldurun.",
        (v) =>
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
          "Lütfen e-posta adresinizi kontrol edip tekrar deneyin.",
      ];
    },
    activeSlides() {
      return window.innerWidth <= 768
        ? this.slides.mobile
        : this.slides.desktop;
    },
  },
};
</script>
<style>
.container.fill-height > .row {
  max-width: calc(100% - 24px);
}
.parent-container {
  margin: 80px;
}
.parent-container > div {
  /* padding: 16px; */
}
.login-hero {
  position: relative;
}
.login-hero img {
  border-radius: 24px;
  width: 100%;
  /* height: 500px; */
}
.login-hero-container {
  border-radius: 24px;
  padding-top: 0;
}
.login-hero-text {
  top: 55%;
  width: 75%;
  position: absolute;
  color: white;
  font-size: 36px;
  padding-left: 10px;
}
.company-infos {
  margin-top: 24px;
  display: grid;
  width: 100%;
  gap: 16px;
  grid-template-columns: 1fr 1fr 1fr;
}
.company-info {
  background-color: white;
  border-radius: 24px;
  border: 1px solid #e4e7ec;
  padding: 24px;
  color: #504246;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.company-info h4 {
  font-size: 48px;
}
.company-info h5 {
  font-size: 30px;
}
.company-info img {
  width: 64px;
}
.v-input--selection-controls {
  margin-top: 0 !important;
}
.v-input--selection-controls .v-input__slot {
  align-items: flex-start;
}
.consent-checkbox-container {
  display: flex;
  text-align: left;
  gap: 4px;
  align-items: flex-start;
  margin: 16px 0;
}
.consent-checkbox-text {
  font-size: 14px !important;
  color: #101828 !important;
}
.v-input--selection-controls .v-input__slot a {
  font-weight: 500;
  color: #101828 !important;
}
@media only screen and (max-width: 768px) {
  .login-hero img {
    /* height: 350px; */
  }
  .parent-container {
    margin: 12px;
  }
  .company-infos {
    grid-template-columns: 1fr;
  }
  .company-info {
    width: 100%;
    flex-direction: row;
  }
  .login-hero-text {
    font-size: 22px;
    max-width: 300px;
  }
  .login-hero-container {
    padding: 0;
    padding-top: 12px !important;
  }
}
.apply-otp {
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.apply-otp p {
  font-size: 18px;
  color: #504246;
}
.apply-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-top: 80px;
}
.apply-success .description {
  gap: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.apply-success .description h3 {
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
}
.apply-success .description p {
  color: #667085;
  font-size: 16px;
}
.contract-card {
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.contract-content {
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  max-height: 400px;
  overflow-y: auto;
}
</style>
